var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVieweetLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 32,
    viewBox: "0 0 56 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7968 15.5292C43.6451 15.5292 42.5192 15.8709 41.5618 16.511C40.6044 17.1511 39.8583 18.0609 39.4182 19.1252C38.978 20.1894 38.8635 21.3604 39.0891 22.4898C39.3147 23.6192 39.8703 24.6563 40.6855 25.4698C41.5008 26.2833 42.5391 26.8367 43.669 27.0598C44.7988 27.283 45.9695 27.1659 47.0329 26.7234C48.0962 26.281 49.0044 25.533 49.6424 24.5742C50.2805 23.6154 50.6197 22.4888 50.6172 21.3371C50.6172 20.5733 50.4666 19.8171 50.1739 19.1116C49.8813 18.4061 49.4523 17.7653 48.9117 17.2259C48.3711 16.6864 47.7293 16.2588 47.0232 15.9677C46.3171 15.6766 45.5605 15.5275 44.7968 15.5292Z",
    fill: "#00B1E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8083 0H0.000732422L21.3382 32H23.4707V16.0063L12.8083 0Z",
    fill: "#00269A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4736 16.0061L34.1361 31.9999V10.6624H23.4736V16.0061Z",
    fill: "#D50057"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4736 31.9998H34.1361L23.4736 16.0061V31.9998Z",
    fill: "#0E0333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4713 0H34.1338V10.6625H55.4713V0Z",
    fill: "#FFDD00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1361 0H23.4736V10.6625H34.1361V0Z",
    fill: "#D30505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVieweetLogo);
export default __webpack_public_path__ + "static/media/vieweet-logo.0e3a9059a7f08631a80e1b2121dc427b.svg";
export { ForwardRef as ReactComponent };